import { getApiUrl, getToken } from '../utils/util-functions';
import { AcornWidgetParameters } from '../models/acorn-widget-parameters.model';


// `signal` parameter is used to cancel the request when it's not actual anymore
export const getPublicLinkAcornPromoParametersRequest = async (loanAmount: number, signal?: AbortSignal): Promise<AcornWidgetParameters> => {
  const url = getApiUrl() + '/acorn/promo/loan-details?loan_amount=' + loanAmount;

  const response = await fetch(url, {
    signal,
  });

  if (!response.ok) { // Request failed
    throw new Error(`${ response.status } ${ response.statusText }`);
  }

  const responseJson = await response.json() as AcornWidgetParameters;

  if (!responseJson?.loan_details?.dealerId) { // Server returned invalid data
    throw new Error('Invalid response data from the server');
  }

  return responseJson;
};


// `signal` parameter is used to cancel the request when it's not actual anymore
export const getInvoiceAcornPromoParametersRequest = async (loanAmount: number, signal?: AbortSignal): Promise<AcornWidgetParameters> => {
  const token: string | null = getToken();
  if (!token) {
    throw new Error('Authorization token is not provided');
  }

  const url = `${ getApiUrl() }/acorn/promo/loan-details?loan_amount=${ loanAmount }&token=${ token }`;

  const response = await fetch(url, {
    signal,
  });

  if (!response.ok) { // Request failed
    throw new Error(`${ response.status } ${ response.statusText }`);
  }

  const responseJson = await response.json() as AcornWidgetParameters;

  if (!responseJson?.loan_details?.dealerId) { // Server returned invalid data
    throw new Error('Invalid response data from the server');
  }

  return responseJson;
};
